import styled from 'styled-components';

export const FormContainer = styled.div`
  width: 100%;
  margin: auto;
  overflow: hidden;
`;
